import { currentUserVar } from "_graphql/cache/auth";

export const processUrlData = (data: Record<string, any>) => {
    const currentUser = currentUserVar();
    return btoa(
        JSON.stringify({
            ...data,
            logo: currentUser?.employee?.broker_config?.broker_company_logo || "",
            companyName: currentUser?.employee?.broker_config?.broker_company_name || "",
            ...currentUser?.employee?.broker_config?.broker_address,
        })
    );
};

